import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { buildQrAttendancePayload } from '../utils/qrHelpers';
import './EmployeeQRCode.css';

const EmployeeQRCode = ({ employee }) => {
  const canvasWrapRef = useRef(null);

  if (!employee?.employeeId) return null;

  const payload = buildQrAttendancePayload(employee.employeeId);
  const safeName = (employee.name || 'Employee').replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '_');

  const handleDownload = () => {
    const sourceCanvas = canvasWrapRef.current?.querySelector('canvas');
    if (!sourceCanvas) return;

    const exportSize = 512;
    const exportCanvas = document.createElement('canvas');
    exportCanvas.width = exportSize;
    exportCanvas.height = exportSize;
    const ctx = exportCanvas.getContext('2d');

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, exportSize, exportSize);
    ctx.drawImage(sourceCanvas, 0, 0, exportSize, exportSize);

    const link = document.createElement('a');
    link.href = exportCanvas.toDataURL('image/png');
    link.download = `Helport_QR_${safeName || employee.employeeId}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="employee-qr-card">
      <div className="employee-qr-header">
        <span className="employee-qr-badge">Backup QR</span>
        <p className="employee-qr-hint">Show this on your phone and point it at the attendance terminal camera to record Time In / Time Out.</p>
      </div>

      <div className="employee-qr-canvas-wrap" ref={canvasWrapRef}>
        <QRCodeCanvas
          value={payload}
          size={240}
          level="H"
          includeMargin
          bgColor="#ffffff"
          fgColor="#0a1628"
        />
      </div>

      <div className="employee-qr-meta">
        <span className="employee-qr-name">{employee.name}</span>
        <span className="employee-qr-eid">{employee.eid || employee.employeeId}</span>
      </div>

      <button type="button" className="employee-qr-download-btn" onClick={handleDownload}>
        Download QR Code
      </button>
    </div>
  );
};

export default EmployeeQRCode;
